// Mock data for ZenKo landing page

export const products = [
  {
    id: 1,
    name: 'Melatonina para Niños',
    description: 'Descanso reparador para los más pequeños',
    benefits: 'Fórmula suave que ayuda a regular el ciclo de sueño de forma natural y segura',
    image: 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/ro59frqa_CleanShot%202026-02-03%20at%2011.26.30.png',
    category: 'sleep'
  },
  {
    id: 2,
    name: 'Ashwagandha',
    description: 'Manejo natural del estrés y equilibrio hormonal',
    benefits: 'Adaptógeno natural que ayuda a reducir el estrés, mejorar el sueño y aumentar la energía',
    image: 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/qy5a3kzf_CleanShot%202026-02-03%20at%2011.27.17.png',
    category: 'stress'
  },
  {
    id: 3,
    name: 'Maca',
    description: 'Energía sostenida y vitalidad natural',
    benefits: 'Aumenta la energía, mejora el rendimiento físico y apoya el equilibrio hormonal',
    image: 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/rr05f2oi_CleanShot%202026-02-03%20at%2011.28.24.png',
    category: 'energy'
  },
  {
    id: 4,
    name: 'Aceite de Coco',
    description: 'Bienestar general y energía natural',
    benefits: 'Rico en MCT para energía rápida, apoya la función cognitiva y el metabolismo saludable',
    image: 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/dgsfwd1i_CleanShot%202026-02-03%20at%2011.29.20.png',
    category: 'wellness'
  },
  {
    id: 5,
    name: 'Magnesio',
    description: 'Soporte muscular y relajación profunda',
    benefits: 'Esencial para función muscular, salud ósea, reducción de calambres y mejor descanso',
    image: 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/sprebqcd_CleanShot%202026-02-03%20at%2011.29.47.png',
    category: 'recovery'
  },
  {
    id: 6,
    name: 'Colágeno + C',
    description: 'Belleza y vitalidad desde dentro',
    benefits: 'Apoya la salud de piel, cabello, uñas y articulaciones. Vitamina C potencia la absorción del colágeno',
    image: 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/kir2eeyz_CleanShot%202026-02-03%20at%2011.30.11.png',
    category: 'beauty'
  }
];

export const objectives = [
  {
    id: 'energia',
    title: 'Energía y vitalidad',
    description: 'Apoya tu rutina con opciones pensadas para mantenerte constante y con buen ritmo.',
    icon: 'Zap'
  },
  {
    id: 'estres',
    title: 'Estrés y descanso',
    description: 'Suplementos que pueden acompañar hábitos de calma, descanso y balance.',
    icon: 'Moon'
  },
  {
    id: 'digestion',
    title: 'Digestión y microbiota',
    description: 'Alternativas enfocadas en apoyar tu bienestar digestivo y tu rutina alimenticia.',
    icon: 'Heart'
  },
  {
    id: 'defensas',
    title: 'Defensas y bienestar general',
    description: 'Apoyo para hábitos saludables y cuidado diario durante todo el año.',
    icon: 'Shield'
  },
  {
    id: 'belleza',
    title: 'Belleza y longevidad',
    description: 'Nutrición interna para piel radiante, cabello fuerte y envejecimiento saludable.',
    icon: 'Sparkles'
  },
  {
    id: 'familia',
    title: 'Cuidado familiar y personal',
    description: 'Soluciones suaves para los pequeños y cuidado consciente.',
    icon: 'Users'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'María González',
    text: 'Me ayudaron a elegir lo que realmente necesitaba. Súper fácil y rápido por WhatsApp.',
    rating: 5
  },
  {
    id: 2,
    name: 'Carlos Ramírez',
    text: 'Compré mis vitaminas y el envío fue rápido. Me gustó que me explicaran sin complicarme.',
    rating: 5
  },
  {
    id: 3,
    name: 'Ana Martínez',
    text: 'Tenía dudas entre varios suplementos y me orientaron según mi objetivo y presupuesto.',
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: '¿Cómo sé qué suplemento necesito?',
    answer: 'Escríbenos tu objetivo (energía, estrés, digestión, defensas, etc.) y te hacemos preguntas rápidas para orientarte.'
  },
  {
    id: 2,
    question: '¿Puedo combinar varios suplementos?',
    answer: 'En muchos casos sí, pero depende de tu situación. Te guiamos para que sea algo simple y coherente.'
  },
  {
    id: 3,
    question: '¿Cuánto tarda en notarse?',
    answer: 'Varía según el suplemento, el hábito y la constancia. Te ayudamos a armar una rutina realista.'
  },
  {
    id: 4,
    question: '¿Hacen envíos?',
    answer: 'Sí, hacemos envíos a todo El Salvador.'
  },
  {
    id: 5,
    question: '¿Esto reemplaza una consulta médica?',
    answer: 'No. La información es educativa y no sustituye consejo médico, especialmente si hay condiciones o medicación.'
  }
];

export const whatsappNumber = '+50369768437';
export const whatsappLink = 'https://wa.me/50369768437?text=Hola,%20me%20gustar%C3%ADa%20recibir%20informaci%C3%B3n%20sobre%20los%20suplementos%20de%20Zenko';

export const catalogUrl = 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/zylxmpdm_Cata%CC%81logo%20ZenKo.pdf';

export const vitrineaLink = 'https://vitrinnea.com.sv/shop/www.zenkosv.com';

export const zenImages = {
  zen2: 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/x959fm30_zen2.jpg',
  zen3: 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/6k8fohd8_zen3.jpg',
  zen5: 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/mdyrpc2m_zen5.jpg'
};

export const darkLogo = 'https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/dyu5c0lc_View%20recent%20photos.png';